import { render, staticRenderFns } from "./V2BaseFileInput.vue?vue&type=template&id=3baee952"
import script from "./V2BaseFileInput.vue?vue&type=script&lang=js"
export * from "./V2BaseFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports